/**
 * 이미지 캐시 무효화 헬퍼
 *
 * public/ 폴더의 정적 이미지는 webpack 해시 처리가 되지 않아
 * 파일을 교체해도 브라우저 캐시가 예전 이미지를 재사용하는 문제를 해결합니다.
 *
 * vue.config.js에서 빌드 시점에 주입한 VUE_APP_BUILD_TIME을 쿼리 파라미터로 붙여
 * 매 빌드마다 URL이 변경되도록 하여 브라우저가 새 이미지를 fetch하도록 강제합니다.
 */

const BUILD_VERSION = process.env.VUE_APP_BUILD_TIME || 'dev'

/**
 * 이미지 경로에 버전 쿼리 파라미터를 추가합니다.
 * @param {string} path - 이미지 경로 (예: '/images/youth-card.jpg')
 * @returns {string} 버전 파라미터가 추가된 경로 (예: '/images/youth-card.jpg?v=1706234567890')
 */
export function versionedImage(path) {
  if (!path) return path
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}v=${BUILD_VERSION}`
}
